import React from 'react';
import { useSelector } from 'react-redux';
import { hasPermission } from '../../config/rbac';

// <PermissionGate resource="claims" action="create">
//   <Button>+ New Claim</Button>
// </PermissionGate>
//
// Reads the logged-in user's role from redux and hides `children` when the
// role isn't in the RBAC allow-list. Backend enforcement is authoritative;
// this component just prevents dead buttons.
//
// Accepts an optional `fallback` element for cases where you want to show
// something (e.g. a disabled state) instead of nothing.
const PermissionGate = ({ resource, action, fallback = null, children }) => {
  const role = useSelector((state) => {
    // Two shapes appear in this codebase:
    //   state.userLogin.userInfo.data.data.role   (modern — getLoggedinUserAction)
    //   state.userLogin.userInfo.data.user.role   (legacy login response)
    const info = state?.userLogin?.userInfo?.data;
    return info?.data?.role || info?.user?.role;
  });

  if (!hasPermission(role, resource, action)) return fallback;
  return <>{children}</>;
};

export default PermissionGate;
